import { useQuery } from '@tanstack/react-query';
import { warrantyApi } from '../api/warrantyApi';

/**
 * Hook pour récupérer le PDF d'une garantie sous forme de Blob
 * Le Blob est mis en cache par React Query
 * Chaque composant doit créer sa propre URL et la révoquer
 */
export const useWarrantyPdfBlob = (uuid: string | undefined, enabled = true) => {
  const query = useQuery({
    queryKey: ['warranty-pdf', uuid],
    queryFn: async () => {
      if (!uuid) throw new Error('UUID requis');
      const blob = await warrantyApi.downloadWarrantyPdf(uuid);
      return blob; // Retourne le Blob directement
    },
    enabled: enabled && !!uuid,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });

  return query;
};

